import { styled } from "@mui/material/styles";
import { Pagination as MuiPagination } from "@mui/material";
import { colors } from "../pages/css components/Style";

const BasicPagination = styled(MuiPagination)(({ theme }) => ({
  marginTop: "10px",
  "& .MuiPaginationItem-root": {
    color: "#333",
    fontSize: "15px",
    border: `1px solid ${colors.text}`,
    "&:hover": {
      background: colors.hoverBlue,
    },
  },
  "& .Mui-selected": {
    color: "#fff",
    backgroundColor: colors.publicisBlue,
    border: `1px solid ${colors.publicisBlue}`,
  },
}));

export default function Pagination(props) {
  return <BasicPagination variant="outlined" {...props} />;
}
